module.exports = __webpack_public_path__ + "img/26.39f77640.jpg";